import { SmartDisplayOutlined } from '@mui/icons-material';
import { Avatar, Box, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import classSet from 'react-classset';
import { useSelector } from 'react-redux';

import type { VNSortableItemTemplateProps } from '@/components/VNSortable/VNSortableItem';
import { applicationDataSelector } from '@/store/slices/application-data';
import { dateUtils } from '@/utils/dateUtils';

const VNAccessScheduleCard = ({ item, index, sortableId }: VNSortableItemTemplateProps) => {
  const { ouData } = useSelector(applicationDataSelector);

  return (
    <Box
      className={classSet({ 'vn-access-schedule-card': true, active: item.isActive, controlling: item.isControlling })}
      key={`${sortableId}`}
      display="flex"
      alignItems="center"
      p={2}
      borderRadius="12px"
      border="1px solid #ddd"
      sx={{ boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', width: '100%', marginBottom: '8px' }}
    >
      {/* Left: Circular Icon */}
      <Avatar
        sx={{
          bgcolor: blue[100],
          color: blue[700],
          width: 40,
          height: 40,
          mr: 2,
        }}
      >
        <SmartDisplayOutlined />
      </Avatar>
      {/* Middle: Date & Access Level */}
      <Box flex="1">
        <Typography variant="body1" fontWeight={500}>
          {item.from == null &&
            item.to != null &&
            `Before ${dateUtils.format(item.to, ouData.timezone)} (${ouData.timezoneAbbreviation})`}
          {item.from != null &&
            item.to == null &&
            `After ${dateUtils.format(item.from, ouData.timezone)} (${ouData.timezoneAbbreviation})`}
          {item.from != null &&
            item.to != null &&
            `${dateUtils.format(item.from, ouData.timezone)} (${ouData.timezoneAbbreviation}) to ${dateUtils.format(
              item.to,
              ouData.timezone
            )} (${ouData.timezoneAbbreviation})`}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {item.accessLevel || 'No Access'}
        </Typography>
      </Box>
      {/* Right: Delete Button */}
      {/* <IconButton onClick={() => remove(index)} color="primary">
        <DeleteOutline />
      </IconButton> */}
      <div className="background-div" />
    </Box>
  );
};

export default VNAccessScheduleCard;
